export const AUTH_INPUT_BASE_CLASS =
  "login-input login-input-size text-dark-2 rounded-xl bg-white border border-gray-300 shadow-sm w-full placeholder:text-gray-400"

export const AUTH_INPUT_CLASS = `${AUTH_INPUT_BASE_CLASS} hover:border-gray-400 focus-within:border-primary focus-within:shadow-none`

export const AUTH_INPUT_INNER_CLASS = {
  input: "text-dark-2 text-sm bg-transparent w-full placeholder:text-gray-400"
}
